<template>
  <div class="formulario-modelo">
    <!-- Overlay de carga -->
    <LoadingOverlay :visible="loading" :message="loadingMessage" />

    <!-- Contenido -->
    <div v-if="!loading">

      <!-- Panel Versus: aparece cuando no hay indicadores cargados -->
      <div v-if="mostrarPanelVersus" class="vs-wrapper">
        <div class="vs-encabezado">
          <h1>¿Qué deseas hacer?</h1>
          <p>Selecciona una de las dos opciones para continuar</p>
        </div>
        <div class="vs-grid">
          <div class="vs-card vs-card--azul">
            <h2>Agregar indicadores e instrumentos</h2>
            <p class="vs-desc">Acceda a la vista para configurar manualmente los indicadores e instrumentos del modelo.</p>
            <button class="vs-btn vs-btn--azul" type="button" @click="elegirAgregarIndicadores">Aceptar</button>
          </div>
          <div class="vs-card vs-card--amarillo">
            <h2>Modelo Histórico</h2>
            <p class="vs-desc">El modelo ya tiene su estructura definida. Al aceptar, avanzará directamente al proceso de calificación sin necesidad de agregar indicadores ni instrumentos.</p>
            <button class="vs-btn vs-btn--amarillo" type="button" @click="() => elegirSinIndicadores()" :disabled="loadingAccion">
              {{ loadingAccion ? 'Generando...' : 'Aceptar' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Vista normal de indicadores -->
      <template v-else>
        <div class="header-flex">
          <div>
            <h1>Agregar Indicadores</h1>
            <p v-if="nombreVersion" class="ctx-modelo">{{ nombreVersion }}</p>
          </div>
          <div class="acciones-header">
            <button class="btn salir" :disabled="loadingAccion || loading" @click="mostrarConfirmarVolverHistorico = true">
              Volver Histórico
            </button>
            <button class="btn guardar" :disabled="loadingAccion || loading" @click="mostrarCrearFormulario = true">
              ➕ Crear Formulario
            </button>
            <button class="btn guardar" :disabled="loadingAccion || loading" @click.prevent="validarYCompletar">
              {{ loadingAccion ? 'Completando versión...' : 'Completar Modelo' }}
            </button>
          </div>
        </div>

        <!-- Filtro por tipo de indicador -->
        <div class="filtros-tipo">
          <button class="btn-filtro" :class="{ activo: filtroTipo === '' }" @click="filtroTipo = ''">Todos</button>
          <button class="btn-filtro" :class="{ activo: filtroTipo === 'documental' }" @click="filtroTipo = 'documental'">Documental</button>
          <button class="btn-filtro" :class="{ activo: filtroTipo === 'cuantitativa' }" @click="filtroTipo = 'cuantitativa'">Cuantitativa</button>
          <button class="btn-filtro" :class="{ activo: filtroTipo === 'opinion' }" @click="filtroTipo = 'opinion'">Opinión</button>
        </div>

        <div class="marco">
          <!-- Tabla/árbol de componentes con indicadores -->
          <ModificarComponentes
            :componentes="nodosConIndicadoresFiltrados"
            :idComponenteRaiz="idComponenteRaiz"
            :esIndicadores="true"
            :esIndicadorFn="esNodoIndicador"
            :instrumentosPorIndicadorFn="instrumentosPorIndicadorFn"
            :niveles="nivelesArray"
            :obtenerNumeracion="obtenerNumeracionJerarquica"
            :loading="loadingAccion || loading"
            @modificarIndicador="onModificarIndicador"
            @eliminarIndicador="onEliminarIndicador"
            @agregarHijo="onAgregarIndicador"
            @agregarInstrumento="onAgregarInstrumento"
            @vincularFormulario="onVincularFormulario"
            @modificarInstrumento="onModificarInstrumento"
            @eliminarInstrumento="onEliminarInstrumento"
          />

          <!-- Modal para agregar indicador -->
          <FormularioIndicador
            :visible="mostrarFormAgregar"
            modo="agregar"
            :loading="loadingAccion"
            :tiposDisponibles="tiposDisponibles"
            :unidadesDisponibles="unidadesDisponibles"
            :formulasDisponibles="formulasDisponibles"
            :nombresDisponibles="nombresDisponibles"
            @aceptar="onAceptarAgregar"
            @cancelar="cancelarAgregar"
          />

          <!-- Modal para modificar indicador -->
          <FormularioIndicador
            :visible="mostrarFormModificar"
            modo="modificar"
            :loading="loadingAccion"
            :tiposDisponibles="tiposDisponibles"
            :unidadesDisponibles="unidadesDisponibles"
            :formulasDisponibles="formulasDisponibles"
            :nombresDisponibles="nombresDisponibles"
            :tipoInicial="editandoIndicador?.id_tipo_componente ?? ''"
            :nombreInicial="editandoIndicador?.enunciado ?? editandoIndicador?.nombre ?? ''"
            :unidadInicial="editandoIndicador?.unidades ?? ''"
            :formulaInicial="editandoIndicador?.formula ?? ''"
            :descripcionInicial="editandoIndicador?.descripcion ?? ''"
            @aceptar="onAceptarModificar"
            @cancelar="cancelarModificar"
          />

          <!-- Confirmar eliminación de indicador -->
          <MensajeConfirmacion
            :visible="mostrarConfirmarEliminar"
            title="Confirmar eliminación"
            message="Al eliminar el indicador también se eliminarán todos los instrumentos asociados y la tabla de relación. ¿Desea continuar?"
            confirmText="Eliminar"
            cancelText="Cancelar"
            :confirmLoading="loading"
            @confirm="confirmarEliminarIndicador"
            @cancel="mostrarConfirmarEliminar = false"
          />
          <!-- Confirmar desvinculación de instrumento -->
          <MensajeConfirmacion
            :visible="mostrarConfirmarEliminarInstrumento"
            title="Confirmar desvinculación de instrumento"
            :message="mensajeEliminarInstrumento"
            confirmText="Desvincular"
            cancelText="Cancelar"
            :confirmLoading="loading"
            @confirm="confirmarEliminarInstrumento"
            @cancel="mostrarConfirmarEliminarInstrumento = false"
          />
        </div>

        <!-- Botones inferiores -->
        <div class="botones">
          <button class="btn salir" @click="salir">Salir</button>
          <button class="btn guardar" :disabled="loadingAccion || loading" @click.prevent="validarYCompletar">
            {{ loadingAccion ? 'Completando versión...' : 'Completar Modelo' }}
          </button>
          <!-- Modal para avanzar sin cumplir validación completa -->
          <MensajeConfirmacion
            :visible="mostrarAvanzarHistorico"
            title="Validación incompleta"
            message="El modelo no cumple todos los requisitos. ¿Desea completarlo de todos modos?"
            confirmText="Avanzar de todos modos"
            cancelText="Cancelar"
            :confirmLoading="loadingAccion"
            @confirm="mostrarAvanzarHistorico = false; CompletarModelo()"
            @cancel="mostrarAvanzarHistorico = false"
          />
          <!-- Modal para confirmar completar modelo -->
          <MensajeConfirmacion
            :visible="mostrarConfirmar"
            title="Confirmar acción"
            message="Al completar el modelo, la versión quedará disponible para ser asignada a nuevos procesos de autoevaluación. ¿Desea continuar?"
            confirmText="Aceptar"
            cancelText="Cerrar"
            :confirmLoading="loadingAccion"
            @confirm="CompletarModelo"
            @cancel="mostrarConfirmar = false"
          />
        </div>
      </template>

    </div>
    
    <!-- Modal de Instrumentos (todos los tipos) -->
    <InstrumentosView
      :visible="mostrarModalInstrumento"
      :idTipoComponente="instrumentoIdTipoComponente"
      :idIndicador="instrumentoIdIndicador"
      :idInstrumento="instrumentoIdInstrumento"
      @cerrar="cerrarModalInstrumento"
    />
    
    <MensajeConfirmacion
      :visible="mostrarReintentoIndicadores"
      title="Indicadores incompletos"
      :message="`No se pudo generar indicador para ${componentesFallidos.length} componente(s): ${componentesFallidos.map(c => c.nombre).join(', ')}. ¿Desea volver a intentarlo?`"
      confirmText="Reintentar"
      cancelText="Cancelar"
      :confirmLoading="loadingAccion"
      @confirm="mostrarReintentoIndicadores = false; elegirSinIndicadores(componentesFallidos)"
      @cancel="mostrarReintentoIndicadores = false"
    />

    <!-- Modal: Volver Histórico -->
    <div v-if="mostrarConfirmarVolverHistorico" class="modal-overlay">
      <div class="modal-vs-contenido">
        <div class="vs-encabezado">
          <h1>¿Cómo desea proceder?</h1>
          <p>Selecciona una de las opciones para continuar</p>
        </div>
        <div class="vs-grid">
          <div class="vs-card vs-card--azul">
            <h2>Volver Histórico</h2>
            <p class="vs-desc">Al volver a modelo histórico se procederá a preparar la versión para que se pueda iniciar un proceso y subir la calificación de cada aspecto.</p>
            <button class="vs-btn vs-btn--azul" :disabled="loadingAccion" @click="mostrarConfirmarVolverHistorico = false; elegirSinIndicadores()">
              {{ loadingAccion ? 'Generando...' : 'Aceptar' }}
            </button>
          </div>
          <div class="vs-card vs-card--amarillo">
            <h2>Dejar como está</h2>
            <p class="vs-desc">Esta opción vuelve el modelo histórico pero los aspectos que no tengan un indicador no se agregarán para su calificación.</p>
            <button class="vs-btn vs-btn--amarillo" :disabled="loadingAccion" @click="avanzarSinGenerar">
              Dejar como está y avanzar
            </button>
          </div>
        </div>
        <div class="modal-vs-cancelar">
          <button class="btn salir" @click="mostrarConfirmarVolverHistorico = false">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Crear un formulario de opinión con sus preguntas, sin atarlo a un indicador -->
    <CrearFormularioModal
      :visible="mostrarCrearFormulario"
      @cerrar="mostrarCrearFormulario = false"
      @creado="onFormularioCreado"
    />

    <!-- Modificar un formulario de opinión existente -->
    <ModificarFormularioModal
      :visible="mostrarModificarFormulario"
      :idInstrumento="instrumentoIdParaModificar"
      @cerrar="mostrarModificarFormulario = false"
      @guardado="onFormularioModificado"
    />

    <!-- Vincular un formulario de opinión ya creado y elegir sus preguntas -->
    <VincularFormularioModal
      :visible="mostrarVincularFormulario"
      :idIndicador="indicadorParaVincular?.id_indicador ?? null"
      :nombreIndicador="indicadorParaVincular?.enunciado ?? null"
      :ruta="rutaParaVincular"
      @cerrar="mostrarVincularFormulario = false"
      @vinculado="onFormularioVinculado"
    />

    <MensajeFlotante
      :visible="mensajeVisible"
      :mensaje="mensajeTexto"
      :tipo="mensajeTipo"
      @cerrar="mensajeVisible = false"
    />
  </div>
</template>

<script lang="ts" setup>
/**
 * Alta de indicadores sobre los aspectos de una versión.
 *
 * Un indicador se crea colgado de un aspecto, y un aspecto está activo en la
 * versión solo si tiene indicador en ella. Requiere la VERSIÓN en `edicion`.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/version/:id_version/indicadores` (AgregarIndicadores) — permiso `indicadores.crear`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useComponentes } from '@/store/GestionComponentes'
import { useGestionVersiones } from '@/store/GestionVersiones'
import useModelo from '@/store/GestionModelo'
import { useGestionTipoComponente } from '@/store/GestionTipoComponente'
import { useGestionIndicadores } from '@/store/GestionIndicadores' 
import type Componente from '@/interfaces/Componente'
import type Indicador from '@/interfaces/Indicador'
import type TipoComponente from '@/interfaces/TipoComponente'
import MensajeConfirmacion from '@/components/MensajeConfirmacion.vue'
import ModificarComponentes from '@/components/ModificarComponentes.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import FormularioIndicador from '@/components/FormularioIndicador.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import VincularFormularioModal from '@/components/VincularFormularioModal.vue'
import CrearFormularioModal from '@/components/CrearFormularioModal.vue'
import ModificarFormularioModal from '@/components/ModificarFormularioModal.vue'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'
import { useGestionInstrumento } from '@/store/GestionInstrumentos'
import type Instrumento from '@/interfaces/Instrumetos'
import InstrumentosView from '@/views/InstrumentosView.vue'
import { limpiarNiveles } from '@/utils/nivelesHelper'
import { podarPorEnfoque, podarGruposVariante } from '@/utils/estructuraActiva'

const route = useRoute()
const router = useRouter()
const store = useComponentes()
const versionStore = useGestionVersiones()
const modeloStore = useModelo()
const tipoStore = useGestionTipoComponente()
const indicadoresStore = useGestionIndicadores() 
const idVersion = Number(route.params.id_version ?? NaN)
const loading = ref(false)
const loadingMessage = ref('Cargando indicadores...')
const loadingAccion = ref(false)
const nombreModelo = ref('')
const nombreVersion = ref('')
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}
const mostrarPanelVersus = ref(false)
const mostrarConfirmar = ref(false)
const mostrarAvanzarHistorico = ref(false)
const nivelesArray = ref<string[]>([])
const idComponenteRaiz = ref<number | null>(null)
const ultimosNivelesIniciales = ref<Componente[]>([])
const indicadorInstrumentoStore = useGestionIndicadorInstrumentos()
const instrumentosStore = useGestionInstrumento()
const componentesFallidos = ref<typeof ultimosNivelesIniciales.value>([])
const mostrarReintentoIndicadores = ref(false)
const mostrarConfirmarVolverHistorico = ref(false)
const mostrarConfirmarEliminar = ref(false)
const indicadorAEliminar = ref<Indicador | null>(null)
const mostrarConfirmarEliminarInstrumento = ref(false)
const instrumentoAEliminar = ref<Instrumento | null>(null)
const indicadorDelInstrumentoAEliminar = ref<Indicador | null>(null)
const mensajeEliminarInstrumento = ref('')

// Estados para modal de instrumentos
const mostrarModalInstrumento = ref(false)
const instrumentoIdTipoComponente = ref<number>(0)
const instrumentoIdIndicador = ref<number>(0)
const instrumentoIdInstrumento = ref<number | null>(null)

// Estado para modificar formulario de opinión
const mostrarModificarFormulario = ref(false)
const instrumentoIdParaModificar = ref<number | null>(null)

// Ruta jerárquica del indicador activo para VincularFormularioModal
const rutaParaVincular = ref<{ etiqueta: string; nombre: string }[]>([])

function construirRutaComponente(idComponente: number): { etiqueta: string; nombre: string }[] {
  const ruta: { etiqueta: string; nombre: string }[] = []
  let id: number | null | undefined = idComponente
  while (id != null) {
    const aplanado = componentesAplanados.value.find(c => c.ref.id_componente === id)
    if (!aplanado) break
    ruta.unshift({
      etiqueta: obtenerNumeracionJerarquica(aplanado.ref, aplanado.nivel),
      nombre: aplanado.ref.nombre
    })
    id = aplanado.ref.padre_id
  }
  return ruta
}

// Estado para modales de agregar/modificar
const tiposDisponibles = ref<TipoComponente[]>([])
const unidadesDisponibles = ref<{ id_unidad: number; nombre: string }[]>([])
const formulasDisponibles = ref<{ id_formula: number; nombre: string; clasificacion?: string }[]>([])
const nombresDisponibles = ref<{ id_nombre: number; nombre: string }[]>([])
const mostrarFormAgregar = ref(false)
// Formularios de opinión: crear uno suelto y vincularlo a un indicador
const mostrarCrearFormulario = ref(false)
const mostrarVincularFormulario = ref(false)
const indicadorParaVincular = ref<Indicador | null>(null)
const mostrarFormModificar = ref(false)
const padreSeleccionado = ref<Componente | null>(null)
const editandoIndicador = ref<Indicador | null>(null)

interface ComponenteAplanado {
  ref: Componente
  nivel: number
}

const componentesAplanados = ref<ComponenteAplanado[]>([])

function aplanarComponentes(arbol: Componente[], nivel = 0): ComponenteAplanado[] {
  const resultado: ComponenteAplanado[] = []
  for (const comp of arbol) {
    if (nivel > 0) resultado.push({ ref: comp, nivel })
    if ((comp.children?.length ?? 0) > 0) {
      resultado.push(...aplanarComponentes(comp.children!, nivel + 1))
    }
  }
  return resultado
}

function obtenerPadreRef(padreId: number | null | undefined): Componente | null {
  if (padreId == null) return null
  return componentesAplanados.value.find(c => c.ref.id_componente === padreId)?.ref ?? null
}

function obtenerNumeracionJerarquica(componente: Componente, _nivel: number): string {
  const aplanado = componentesAplanados.value.find(c => c.ref.id_componente === componente.id_componente)
  if (!aplanado) return ''

  const numeros: number[] = []
  let actual: ComponenteAplanado | null = aplanado

  while (actual && actual.nivel > 0) {
    const padre = obtenerPadreRef(actual.ref.padre_id)
    if (!padre) {
      const hermanos = componentesAplanados.value
        .filter(c => c.nivel === 1)
        .sort((a, b) => (a.ref.ordinal ?? '').localeCompare(b.ref.ordinal ?? '', undefined, { numeric: true }))
      const pos = hermanos.findIndex(h => h.ref.id_componente === actual!.ref.id_componente)
      numeros.unshift(pos + 1)
      break
    } else {
      const hermanosSorted = [...(padre.children ?? [])].sort((a, b) =>
        (a.ordinal ?? '').localeCompare(b.ordinal ?? '', undefined, { numeric: true })
      )
      const pos = hermanosSorted.findIndex(h => h.id_componente === actual!.ref.id_componente)
      numeros.unshift(pos + 1)
      actual = componentesAplanados.value.find(c => c.ref.id_componente === padre.id_componente) ?? null
    }
  }

  const numero = numeros.join('.')
  if (!numero) return ''
  const nombreNivel = nivelesArray.value[aplanado.nivel - 1] ?? `Nivel ${aplanado.nivel}`
  return `${nombreNivel} ${numero}`
}

function calcularProfundidad(nodo: Componente, nivel = 1): number {
  if (!nodo.children || nodo.children.length === 0) return nivel
  return Math.max(...nodo.children.map(h => calcularProfundidad(h, nivel + 1)))
}

function obtenerUltimoNivel(nodo: Componente, nivelActual = 1, nivelMaximo: number): Componente[] {
  if (nivelActual === nivelMaximo) return [nodo]
  if (!nodo.children) return []
  return nodo.children.flatMap(h => obtenerUltimoNivel(h, nivelActual + 1, nivelMaximo))
}


// Carga inicial
onMounted(async () => {
  loading.value = true
  try {
    // Versión y modelo
    const version = await versionStore.getVersionById(idVersion)
    nombreVersion.value = version?.nombre ?? ''
    if (version?.id_modelo) {
      const modelo = await modeloStore.getModeloById(version.id_modelo)
      nombreModelo.value = modelo?.nombre ?? ''
      if (modelo?.niveles) {
        nivelesArray.value = limpiarNiveles(modelo.niveles)
      }
    }

    // Raíz y árbol de componentes — C-01: componentes cuelgan del modelo, no de la versión
    const idModelo = version?.id_modelo
    const raiz = idModelo ? await store.cargarRaizPorModelo(idModelo) : null
    if (raiz) {
      idComponenteRaiz.value = raiz.id_componente ?? null
      const ok = await store.cargarArbolDesdeRaiz(idComponenteRaiz.value!, nivelesArray.value)
      if (ok) {
        // Oculta las variantes de otro enfoque y colapsa grupos de variante:
        // de cada grupo_variante solo queda el representante adecuado para la versión.
        const arbolPodado = podarGruposVariante(
          podarPorEnfoque(store.componentes, version?.enfoque),
          version?.enfoque
        )
        componentesAplanados.value = aplanarComponentes(arbolPodado)
        const raizCompleta = arbolPodado.find(c => c.id_componente === idComponenteRaiz.value)
        if (raizCompleta) {
          const nivelMax = calcularProfundidad(raizCompleta)
          ultimosNivelesIniciales.value = obtenerUltimoNivel(raizCompleta, 1, nivelMax)
        }
      }
    }

    const [tipos] = await Promise.all([
      tipoStore.getTipos(),
      indicadoresStore.cargarTodos(),
      instrumentosStore.cargarTodos(),
      indicadorInstrumentoStore.getRelaciones()
    ])
    tiposDisponibles.value = tipos ?? []

// Unidades únicas
const unidadesUnicas = Array.from(
  new Set(
    indicadoresStore.indicadores
      .map(i => i.unidades)
      .filter((v): v is string => typeof v === 'string' && v.trim().length > 0)
      .map(v => v.trim())
  )
)

unidadesDisponibles.value = unidadesUnicas.map((nombre, idx) => ({
  id_unidad: idx + 1,
  nombre
}))

// Fórmulas únicas agrupadas por clasificación de indicador
const formulasPorClasif = new Map<string, { id_formula: number; nombre: string; clasificacion: string }>()
let idxF = 0
for (const ind of indicadoresStore.indicadores) {
  if (!ind.formula?.trim()) continue
  const nombre = ind.formula.trim()
  const tipo = tiposDisponibles.value.find(t => t.id_tipo_componente === ind.id_tipo_componente)
  const nombreTipo = (tipo?.nombre ?? '').toLowerCase()
  const clasificacion = /document/.test(nombreTipo)
    ? 'documental'
    : /cuantitativ/.test(nombreTipo)
    ? 'cuantitativa'
    : /opini/.test(nombreTipo)
    ? 'opinion'
    : 'otro'
  const key = `${clasificacion}::${nombre.toLowerCase()}`
  if (!formulasPorClasif.has(key)) {
    formulasPorClasif.set(key, { id_formula: ++idxF, nombre, clasificacion })
  }
}
formulasDisponibles.value = [...formulasPorClasif.values()]

const nombresUnicos = Array.from(
  new Set(
    indicadoresStore.indicadores
      .filter(i => i.unidades?.trim() || i.formula?.trim())
      .map(i => (i.enunciado ?? i.nombre ?? '').trim())
      .filter(v => v.length > 0)
  )
)
nombresDisponibles.value = nombresUnicos.map((nombre, idx) => ({
  id_nombre: idx + 1,
  nombre
}))

  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error al cargar datos iniciales.', 'error')
  } finally {
    loading.value = false
  }

  // Mostrar notificación si se viene de crear/modificar un instrumento
  const mensajeInstrumento = sessionStorage.getItem('instrumento_creado')
  if (mensajeInstrumento) {
    mostrarMensaje(mensajeInstrumento, 'positivo')
    sessionStorage.removeItem('instrumento_creado')
  }

  // Mostrar panel versus si no hay indicadores para esta versión
  const indicadoresDeLaVersion = indicadoresStore.indicadores.filter(i => i.id_version === idVersion)
  if (indicadoresDeLaVersion.length === 0) {
    mostrarPanelVersus.value = true
  }
})

const filtroTipo = ref<'' | 'documental' | 'cuantitativa' | 'opinion'>('')

function nombreEsTipo(nombre: string | undefined, filtro: string): boolean {
  if (!nombre) return false
  if (filtro === 'documental') return /document/i.test(nombre)
  if (filtro === 'cuantitativa') return /cuantitativ/i.test(nombre)
  if (filtro === 'opinion') return /opini/i.test(nombre)
  return true
}

// incluye indicadores filtrados por id_componente
const nodosConIndicadores = computed(() => {
  return ultimosNivelesIniciales.value.map(nodo => ({
    ...nodo,
    indicadores: indicadoresStore.indicadores.filter(i => i.id_componente === nodo.id_componente && i.id_version === idVersion)
  }))
})

const nodosConIndicadoresFiltrados = computed(() => {
  if (!filtroTipo.value) return nodosConIndicadores.value
  return nodosConIndicadores.value
    .map(nodo => ({
      ...nodo,
      indicadores: nodo.indicadores.filter(ind => {
        const tipo = tiposDisponibles.value.find(t => t.id_tipo_componente === ind.id_tipo_componente)
        return nombreEsTipo(tipo?.nombre, filtroTipo.value)
      })
    }))
    .filter(nodo => nodo.indicadores.length > 0)
})

function instrumentosPorIndicadorFn(id_indicador: number): Instrumento[] {
  const relaciones = indicadorInstrumentoStore.relaciones.filter(r => r.id_indicador === id_indicador)
  return relaciones
    .map(r => instrumentosStore.instrumentos.find(i => i.id_instrumento === r.id_instrumento))
    .filter((i): i is Instrumento => !!i)
}

const esNodoIndicador = (c: any) => !!c.indicadores

// Abrir modal para agregar indicador
function onAgregarIndicador(payload: { padre: Componente; nivel: number }) {
  padreSeleccionado.value = payload.padre
  mostrarFormAgregar.value = true
}

function cancelarAgregar() {
  padreSeleccionado.value = null
  mostrarFormAgregar.value = false
}

async function onAceptarAgregar(payload: {
  tipoIndicadorId: number | ''
  nuevoTipoNombre: string
  nombreIndicador: string
  unidadIndicadorId: string
  nuevaUnidadNombre: string
  formulaIndicadorId: string
  nuevaFormulaNombre: string
  descripcionIndicador: string
}) {
  if (!padreSeleccionado.value) return
  try {
    loadingAccion.value = true
    const indicador = await guardarIndicador(payload, padreSeleccionado.value)
    if (!indicador) return

    const tipoAuto = detectarTipoAuto(indicador.id_tipo_componente)
    if (tipoAuto) {
      try {
        await crearInstrumentoAutomatico(indicador, tipoAuto)
        mostrarMensaje('Indicador e instrumento creados correctamente.', 'positivo')
      } catch {
        mostrarMensaje('Indicador creado, pero no se pudo generar el instrumento automáticamente.', 'error')
      }
    } else {
      mostrarMensaje('Indicador agregado correctamente.', 'positivo')
    }
    cancelarAgregar()
  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error inesperado al agregar indicador.', 'error')
  } finally {
    loadingAccion.value = false
  }
}

// Abrir modal para modificar indicador
function onModificarIndicador(indicador: Indicador) {
  editandoIndicador.value = indicador
  // Buscar el componente padre
  padreSeleccionado.value = ultimosNivelesIniciales.value.find(
    n => n.id_componente === indicador.id_componente
  ) ?? null
  mostrarFormModificar.value = true
}

function cancelarModificar() {
  editandoIndicador.value = null
  padreSeleccionado.value = null
  mostrarFormModificar.value = false
}

async function onAceptarModificar(payload: {
  tipoIndicadorId: number | ''
  nuevoTipoNombre: string
  nombreIndicador: string
  unidadIndicadorId: string
  nuevaUnidadNombre: string
  formulaIndicadorId: string
  nuevaFormulaNombre: string
  descripcionIndicador: string
}) {
  if (!editandoIndicador.value) return
  try {
    loadingAccion.value = true
    const result = await actualizarIndicador(payload, editandoIndicador.value)
    if (result) {
      mostrarMensaje('Indicador modificado correctamente.', 'positivo')
      cancelarModificar()
    }
  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error inesperado al modificar indicador.', 'error')
  } finally {
    loadingAccion.value = false
  }
}

// Lógica compartida para resolver tipo/unidad/fórmula
async function resolverPayload(payload: {
  tipoIndicadorId: number | ''
  nuevoTipoNombre: string
  nombreIndicador: string
  unidadIndicadorId: string
  nuevaUnidadNombre: string
  formulaIndicadorId: string
  nuevaFormulaNombre: string
  descripcionIndicador: string
}, peso: number | null) {
  let tipoId = payload.tipoIndicadorId as number
  let unidadNombre = ''
  let formulaNombre = ''

  // Crear nuevo tipo si corresponde
  if (payload.nuevoTipoNombre.trim()) {
    const nuevoTipo = await tipoStore.crearTipo({
      nombre: payload.nuevoTipoNombre.trim(),
      ponderacion: peso
    })
    if (!nuevoTipo?.id_tipo_componente) {
      mostrarMensaje('Error al crear nuevo tipo de indicador.', 'error')
      return null
    }
    tipoId = nuevoTipo.id_tipo_componente
    tiposDisponibles.value.push(nuevoTipo)
  }

  // Resolver Unidad
  if (payload.nuevaUnidadNombre.trim()) {
    unidadNombre = payload.nuevaUnidadNombre.trim()
    unidadesDisponibles.value.push({ id_unidad: Date.now(), nombre: unidadNombre })
  } else {
    unidadNombre = payload.unidadIndicadorId || ''
  }

  // Resolver Fórmula
  if (payload.nuevaFormulaNombre.trim()) {
    formulaNombre = payload.nuevaFormulaNombre.trim()
    formulasDisponibles.value.push({ id_formula: Date.now(), nombre: formulaNombre })
  } else {
    formulaNombre = payload.formulaIndicadorId || ''
  }

  return {
    id_tipo_componente: tipoId,
    enunciado: payload.nombreIndicador,
    unidades: unidadNombre,
    descripcion: payload.descripcionIndicador || null,
    formula: formulaNombre,
    fuente_informacion: null,
    peso_opinion: peso
  }
}

async function guardarIndicador(payload: Parameters<typeof resolverPayload>[0], padre: Componente): Promise<import('@/interfaces/Indicador').default | false> {
  const datos = await resolverPayload(payload, padre.peso ?? null)
  if (!datos) return false

  const nuevo = await indicadoresStore.crear(padre.id_componente!, { ...datos, id_version: idVersion })
  if (!nuevo) {
    mostrarMensaje('Error al crear indicador.', 'error')
    return false
  }
  return nuevo
}

function detectarTipoAuto(tipoId: number): 'documental' | 'cuantitativa' | null {
  const tipo = tiposDisponibles.value.find(t => t.id_tipo_componente === tipoId)
  const nombre = tipo?.nombre ?? tipo?.tipo ?? ''
  if (nombreEsTipo(nombre, 'documental')) return 'documental'
  if (nombreEsTipo(nombre, 'cuantitativa')) return 'cuantitativa'
  return null
}

async function crearInstrumentoAutomatico(
  indicador: import('@/interfaces/Indicador').default,
  tipo: 'documental' | 'cuantitativa'
): Promise<void> {
  const herramienta = tipo === 'documental'
    ? 'Ficha de revisión Documental'
    : 'Ficha de revisión de indicadores Estadísticos'

  const nuevoInstrumento = await instrumentosStore.crearInstrumento({
    herramienta,
    descripcion: herramienta,
    id_tipo_componente: indicador.id_tipo_componente
  })
  if (!nuevoInstrumento?.id_instrumento || !indicador.id_indicador) return

  await indicadorInstrumentoStore.crearRelacion({
    id_indicador: indicador.id_indicador,
    id_instrumento: nuevoInstrumento.id_instrumento
  })
}

async function actualizarIndicador(payload: Parameters<typeof resolverPayload>[0], indicador: Indicador) {
  const datos = await resolverPayload(payload, padreSeleccionado.value?.peso ?? null)
  if (!datos) return false

  const actualizado = await indicadoresStore.actualizarIndicador(indicador.id_indicador!, datos)
  if (!actualizado) {
    mostrarMensaje('Error al modificar indicador.', 'error')
    return false
  }
  return true
}

// Eventos de modificar/eliminar
function onEliminarIndicador(indicador: Indicador) {
  indicadorAEliminar.value = indicador
  mostrarConfirmarEliminar.value = true
}

async function confirmarEliminarIndicador() {
  if (!indicadorAEliminar.value) return

  try {
    loading.value = true
    const ok = await indicadoresStore.eliminar(indicadorAEliminar.value.id_indicador!)

    mostrarMensaje(
      ok ? 'Indicador e instrumentos asociados eliminados correctamente.' : 'No se pudo eliminar el indicador.',
      ok ? 'positivo' : 'error'
    )
  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error inesperado al eliminar indicador.', 'error')
  } finally {
    mostrarConfirmarEliminar.value = false
    indicadorAEliminar.value = null
    loading.value = false
  }
}

// Navegar y completar modelo
function salir() {
  router.push({ name: 'ListaVersiones', query: { modo: 'indicadores' } })
}

function elegirAgregarIndicadores() {
  mostrarPanelVersus.value = false
}

async function elegirSinIndicadores(objetivo?: typeof ultimosNivelesIniciales.value) {
  if (loadingAccion.value) return
  loadingAccion.value = true
  loadingMessage.value = 'Generando indicadores...'
  loading.value = true
  const pendientes = objetivo ?? ultimosNivelesIniciales.value
  try {
    const tipoId = tiposDisponibles.value[0]?.id_tipo_componente ?? 1

    // Filtrar los que ya tienen indicador (sin HTTP)
    const compsSinIndicador = pendientes.filter(comp =>
      !indicadoresStore.indicadores.some(
        i => i.id_componente === comp.id_componente && i.id_version === idVersion
      )
    )

    // Crear todos en paralelo
    const resultados = await Promise.allSettled(
      compsSinIndicador.map(comp => indicadoresStore.crear(comp.id_componente!, {
        id_version: idVersion,
        id_tipo_componente: tipoId,
        enunciado: comp.nombre,
        formula: null,
        unidades: null,
        fuente_informacion: null,
        descripcion: null,
        peso_opinion: null
      }))
    )

    const fallidos = compsSinIndicador.filter((_, idx) => {
      const r = resultados[idx]
      return r.status === 'rejected' || !r.value
    })

    if (fallidos.length > 0) {
      componentesFallidos.value = fallidos
      mostrarReintentoIndicadores.value = true
      return
    }

    router.push({ name: 'ProcesoAutoevaluacion' })
  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error al generar indicadores por defecto.', 'error')
  } finally {
    loadingAccion.value = false
    loading.value = false
  }
}

async function avanzarSinGenerar() {
  if (loadingAccion.value) return
  loadingAccion.value = true
  mostrarConfirmarVolverHistorico.value = false
  try {
    router.push({ name: 'ProcesoAutoevaluacion' })
  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error al avanzar.', 'error')
  } finally {
    loadingAccion.value = false
  }
}

// Validar que el modelo cumpla los requisitos mínimos
function validarModeloCompleto(): { valido: boolean; mensaje: string } {
  // Verificar que cada componente del último nivel tenga al menos un indicador
  const componentesSinIndicadores: string[] = []
  const indicadoresSinInstrumentos: string[] = []

  for (const nodo of ultimosNivelesIniciales.value) {
    // Obtener los indicadores de este componente
    const indicadores = indicadoresStore.indicadores.filter(
      i => i.id_componente === nodo.id_componente && i.id_version === idVersion
    )

    // Si no tiene indicadores, agregarlo a la lista
    if (indicadores.length === 0) {
      componentesSinIndicadores.push(nodo.nombre)
      continue
    }

    // Verificar que cada indicador tenga al menos un instrumento
    for (const indicador of indicadores) {
      const instrumentos = instrumentosPorIndicadorFn(indicador.id_indicador!)
      if (instrumentos.length === 0) {
        indicadoresSinInstrumentos.push(`${nodo.nombre} > ${indicador.enunciado ?? indicador.nombre}`)
      }
    }
  }

  if (componentesSinIndicadores.length === 0 && indicadoresSinInstrumentos.length === 0) {
    return { valido: true, mensaje: '' }
  }

  const mensaje = 'Para completar el modelo, todos los componentes deben tener al menos un indicador y todos los indicadores al menos un instrumento.'

  return { valido: false, mensaje }
}

// Validar y mostrar confirmación para completar modelo
function validarYCompletar() {
  const validacion = validarModeloCompleto()

  if (!validacion.valido) {
    mostrarAvanzarHistorico.value = true
    return
  }

  // Si es válido, mostrar confirmación de completar modelo
  mostrarConfirmar.value = true
}

async function CompletarModelo() {
  if (!Number.isFinite(idVersion) || idVersion <= 0) {
    mostrarMensaje('ID de versión inválida.', 'error')
    return
  }
  mostrarMensaje('Modelo guardado exitosamente.', 'positivo')
  router.push({ name: 'ListaVersiones' })
}

// agregar instrumento
async function onFormularioCreado(mensaje: string) {
  mostrarMensaje(mensaje, 'positivo')
  // El formulario nuevo debe aparecer al vincular, así que se refresca la lista.
  await instrumentosStore.cargarTodos()
}

function onVincularFormulario(indicador: Indicador) {
  indicadorParaVincular.value = indicador
  rutaParaVincular.value = indicador.id_componente
    ? construirRutaComponente(indicador.id_componente)
    : []
  mostrarVincularFormulario.value = true
}

async function onFormularioVinculado(mensaje: string) {
  mostrarMensaje(mensaje, 'positivo')
  // La fila del instrumento sale del PIVOTE indicador-instrumento, así que sin
  // recargarlo el formulario recién vinculado no aparecía hasta refrescar la
  // página entera.
  await Promise.all([
    indicadoresStore.cargarTodos(),
    instrumentosStore.cargarTodos(),
    indicadorInstrumentoStore.getRelaciones()
  ])
}

function onAgregarInstrumento(indicador?: Indicador) {
  if (!indicador) {
    console.warn('No se recibió indicador en onAgregarInstrumento')
    return
  }
  instrumentoIdTipoComponente.value = indicador.id_tipo_componente
  instrumentoIdIndicador.value = indicador.id_indicador!
  instrumentoIdInstrumento.value = null
  mostrarModalInstrumento.value = true
}

// modificar instrumento
function onModificarInstrumento(instrumento: Instrumento) {
  if (instrumento.modalidad != null) {
    instrumentoIdParaModificar.value = instrumento.id_instrumento ?? null
    mostrarModificarFormulario.value = true
    return
  }
  const relacion = indicadorInstrumentoStore.relaciones.find(
    r => r.id_instrumento === instrumento.id_instrumento
  )
  instrumentoIdTipoComponente.value = instrumento.id_tipo_componente
  instrumentoIdIndicador.value = relacion?.id_indicador ?? 0
  instrumentoIdInstrumento.value = instrumento.id_instrumento ?? null
  mostrarModalInstrumento.value = true
}

async function onFormularioModificado(mensaje: string) {
  mostrarMensaje(mensaje, 'positivo')
  mostrarModificarFormulario.value = false
  try {
    await Promise.all([
      instrumentosStore.cargarTodos(),
      indicadorInstrumentoStore.getRelaciones()
    ])
  } catch { /* ignorar */ }
}

// cerrar modal de instrumentos y recargar
async function cerrarModalInstrumento() {
  mostrarModalInstrumento.value = false
  instrumentoIdInstrumento.value = null

  // Mostrar el mensaje antes de la recarga para que aparezca inmediatamente
  const mensajeInstrumento = sessionStorage.getItem('instrumento_creado')
  if (mensajeInstrumento) {
    mostrarMensaje(mensajeInstrumento, 'positivo')
    sessionStorage.removeItem('instrumento_creado')
  }

  try {
    await Promise.all([
      instrumentosStore.cargarTodos(),
      indicadorInstrumentoStore.getRelaciones()
    ])
  } catch (err: any) {
    console.error('Error al recargar datos:', err)
  }
}

// desvincular instrumento - mostrar confirmación
function onEliminarInstrumento(payload: { instrumento: Instrumento; indicador: Indicador }) {
  instrumentoAEliminar.value = payload.instrumento
  indicadorDelInstrumentoAEliminar.value = payload.indicador
  mensajeEliminarInstrumento.value = '¿Desea desvincular el instrumento de este indicador? El instrumento permanecerá en el sistema.'
  mostrarConfirmarEliminarInstrumento.value = true
}

// confirmar desvinculación de instrumento
async function confirmarEliminarInstrumento() {
  const instrumento = instrumentoAEliminar.value
  const indicador = indicadorDelInstrumentoAEliminar.value
  if (!instrumento?.id_instrumento || !indicador?.id_indicador) return

  const relacion = indicadorInstrumentoStore.relaciones.find(
    r => r.id_instrumento === instrumento.id_instrumento && r.id_indicador === indicador.id_indicador
  )
  if (!relacion?.id) {
    mostrarMensaje('No se encontró la relación entre el indicador y el instrumento.', 'error')
    mostrarConfirmarEliminarInstrumento.value = false
    return
  }

  try {
    loading.value = true
    const ok = await indicadorInstrumentoStore.eliminarRelacion(relacion.id)

    if (ok) {
      mostrarMensaje('Instrumento desvinculado correctamente.', 'positivo')
      await indicadorInstrumentoStore.getRelaciones()
    } else {
      mostrarMensaje('No se pudo desvincular el instrumento.', 'error')
    }
  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error inesperado al desvincular instrumento.', 'error')
  } finally {
    mostrarConfirmarEliminarInstrumento.value = false
    instrumentoAEliminar.value = null
    indicadorDelInstrumentoAEliminar.value = null
    loading.value = false
  }
}
</script>

<style scoped>
.formulario-modelo {
  background-color: white;
  padding: var(--space-lg);
  border-radius: var(--radius-lg);
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  box-shadow: var(--shadow-md);
  box-sizing: border-box;
  margin: 20px;
  font-family: var(--font-family);
}

h1 {
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.3;
}

.marco {
  border: 2px solid rgb(156, 155, 155);
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.formulario-inicial {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.formulario-opcion {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1;
  margin-bottom: var(--space-base);
}

input,
textarea {
  padding: 0.75rem;
  border: 1px solid #e6e5e5;
  border-radius: var(--radius-md);
  font-size: 1rem;
  font-family: var(--font-family);
  background-color: #f9f9f9;
  height: 40px;
  box-sizing: border-box;
  margin-bottom: var(--space-base);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

input:focus,
textarea:focus {
  outline: none;
  border-color: #0e69a0;
  box-shadow: 0 0 0 3px rgba(14, 105, 160, 0.1);
}

textarea {
  height: auto;
}

.formulario-opcion span {
  color: #8f8e8e;
  margin-bottom: 0.5rem;
}

.formulario-descripcion {
  width: 97%;
  min-height: 100px;
  padding: 0.75rem;
  border: 1px solid #e6e5e5;
  border-radius: var(--radius-md);
  font-size: 1rem;
  font-family: var(--font-family);
  resize: vertical;
  background-color: #f9f9f9;
  flex: 1;
  display: flex;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.formulario-descripcion:focus {
  outline: none;
  border-color: #0e69a0;
  box-shadow: 0 0 0 3px rgba(14, 105, 160, 0.1);
}

.input-personalizado {
  width: 200px;
}

.botones {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  height: 40px;
  font-size: var(--font-size-sm);
  font-family: var(--font-family);
  transition: all 0.15s ease;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.btn.salir {
  background-color: white;
  border: 1px solid #ccc;
}

.btn.salir:hover {
  background-color: rgb(212, 26, 26);
  color: white;
}

.btn.guardar {
  background-color: #eea222;
  color: black;
}

.btn.guardar:hover {
  background-color: #0e69a0;
  cursor: pointer;
  color: white;
}

.divider {
  border: none;
  border-bottom: 1px solid #949393;
  margin: var(--space-lg) 0;
}

.feedback {
  margin-top: .5rem;
  color: #cf0808;
}

.componentes-lista {
  font-family: var(--font-family);
  font-weight: normal;
  padding: 0.5rem 0;
}

.componentes-lista ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.componentes-lista li {
  margin-bottom: 0.5rem;
}

.componentes-lista div {
  font-weight: normal;
  padding: 0.25rem 0;
  cursor: pointer;
}

.componentes-lista [data-nivel] {
  margin-left: calc((var(--nivel, 1) - 1) * 1rem);
}

.header-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ctx-modelo {
  display: inline-block;
  margin: 6px 0 0;
  padding: 3px 10px;
  background: #e8f0f8;
  border-left: 3px solid #0e69a0;
  border-radius: 3px;
  font-size: 0.85rem;
  font-weight: 700;
  color: #111;
  letter-spacing: 0.01em;
}

.acciones-header {
  display: flex;
  gap: 0.5rem;
}

.formulario-inline {
  border: 1px dashed #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  background: #fafafa;
}

.mensaje-positivo {
  color: #0a7d00;
  font-weight: bold;
}

.mensaje-error {
  color: #b00020;
  font-weight: bold;
}

.fila-select-boton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  width: 100%;
}

.fila-select-boton select {
  flex: 1;
  min-width: 300px;
}

.fila-select-boton button {
  white-space: nowrap;
}

.fila-select-boton select {
  flex: 1;
  min-width: 300px;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}

label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  font-size: var(--font-size-sm);
}

label small {
  font-weight: normal;
  font-size: 0.85em;
  color: #666;
  margin-left: 4px;
}

select {
  padding: 0.75rem;
  padding-bottom: 12px;
  border: 1px solid #e6e5e5;
  border-radius: var(--radius-md);
  font-size: 1rem;
  font-family: var(--font-family);
  background-color: #f9f9f9;
  height: 40px;
  box-sizing: border-box;
  margin-bottom: var(--space-base);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

select:focus {
  outline: none;
  border-color: #0e69a0;
  box-shadow: 0 0 0 3px rgba(14, 105, 160, 0.1);
}

.formulario-opcion.nuevo {
  background: linear-gradient(135deg, #fff7e6, #fff3d1);
  border: 2px solid #eea222;
  border-radius: 8px;
  padding: 1rem;
  animation: fadeIn 0.3s ease-in-out;
}

.formulario-opcion.nuevo label {
  color: #0e69a0;
  font-weight: bold;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Panel Versus */
.vs-wrapper {
  padding: 2rem 1rem;
  max-width: 780px;
  margin: 0 auto;
}

.vs-encabezado {
  text-align: center;
  margin-bottom: 1.75rem;
}
.vs-encabezado h1 {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: #111;
}
.vs-encabezado p {
  margin: 6px 0 0;
  font-size: 0.9rem;
  color: #6b7280;
}

.vs-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: stretch;
}

.vs-card {
  background: #fff;
  border-radius: 16px;
  padding: 1.75rem 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.05);
  border-top: 5px solid transparent;
  display: flex;
  flex-direction: column;
  text-align: center;
  transition: transform 0.15s, box-shadow 0.15s;
}
.vs-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05);
}
.vs-card--azul { border-top-color: #0e69a0; }
.vs-card--amarillo { border-top-color: #eea222; }

.vs-card h2 {
  margin: 0 0 0.6rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: #111;
}
.vs-desc {
  margin: 0 0 1.5rem;
  font-size: 0.86rem;
  color: #6b7280;
  line-height: 1.5;
  flex: 1;
}

.vs-btn {
  border: none;
  border-radius: 9px;
  padding: 11px 20px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  width: 100%;
  font-family: var(--font-family);
  transition: background-color 0.15s, color 0.15s;
}
.vs-btn--azul { background: #0e69a0; color: #fff; }
.vs-btn--azul:hover:not(:disabled) { background-color: #0b5580; color: #fff; cursor: pointer; }
.vs-btn--amarillo { background: #eea222; color: black; }
.vs-btn--amarillo:hover:not(:disabled) { background-color: #0e69a0; color: white; cursor: pointer; }
.vs-btn:disabled { opacity: 0.5; cursor: not-allowed; }

@media (max-width: 560px) {
  .vs-grid { grid-template-columns: 1fr; gap: 1.25rem; }
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal-vs-contenido {
  background: white;
  border-radius: 16px;
  padding: 2rem 2rem 1.5rem;
  max-width: 820px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.modal-vs-cancelar {
  display: flex;
  justify-content: center;
  margin-top: 1.25rem;
}

.filtros-tipo {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin: 0.75rem 0;
}

.btn-filtro {
  padding: 0.35rem 1rem;
  border: 1px solid #d0d9e3;
  border-radius: var(--radius-md);
  background: #fff;
  color: #555;
  font-size: 0.83rem;
  font-weight: 600;
  cursor: pointer;
  font-family: var(--font-family);
  transition: all 0.15s;
}

.btn-filtro:hover {
  border-color: #0e69a0;
  color: #0e69a0;
}

.btn-filtro.activo {
  background: #0e69a0;
  border-color: #0e69a0;
  color: #fff;
}
</style>